import { Breadcrumb } from 'antd';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouterConfig } from 'src/routers/urlConfig';
import I18N from 'src/services/I18NService';

interface IBreadcrumbLayoutProps extends RouteComponentProps {
  menuItem: RouterConfig.IMenuItems;
}

class BreadcrumbLayout extends React.Component<IBreadcrumbLayoutProps> {
  breadcrumbMap: Map<string, JSX.Element[]> = new Map<string, JSX.Element[]>();

  constructor(props: IBreadcrumbLayoutProps) {
    super(props);
  }

  getTitles = (path: string) => {
    const list: RouterConfig.IMenuData[] = [];
    for (const firstObj of this.props.menuItem.others) {
      if (!!firstObj.children) {
        for (const secondObj of firstObj.children) {
          if (secondObj.path === path) {
            list.push(firstObj);
            list.push(secondObj);
            break;
          }
        }
      } else {
        if (firstObj.path === path) {
          list.push(firstObj);
        }
      }
    }

    const itemHtml: JSX.Element[] = list.map((item: RouterConfig.IMenuData) => {
      return <Breadcrumb.Item key={item.path}>{I18N.get(item.name)}</Breadcrumb.Item>;
    });

    this.breadcrumbMap.set(path, itemHtml);
    return itemHtml;
  };

  breadcrumbs(): JSX.Element[] | undefined {
    const { location } = this.props;
    if (!!location) {
      const path = location.pathname;
      if (this.breadcrumbMap.has(path)) {
        return this.breadcrumbMap.get(path);
      } else {
        return this.getTitles(path);
      }
    }
    return undefined;
  }

  render() {
    return <Breadcrumb style={{ margin: '16px' }}>{this.breadcrumbs()}</Breadcrumb>;
  }
}

export default withRouter(BreadcrumbLayout);



// WEBPACK FOOTER //
// ./src/components/layouts/BreadcrumbLayout.tsx